import { useState } from "react";
import { Share2, MessageCircle, Instagram, Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "../lib/api";

const getFile = async (productId) => {
  const res = await fetch(`${API}/share/quiz/${productId}/image.jpg`);
  if (!res.ok) throw new Error("image");
  const blob = await res.blob();
  return new File([blob], `tik-hem-aan-${productId}.jpg`, { type: "image/jpeg" });
};

const canShareFile = (file) => !!navigator.canShare && navigator.canShare({ files: [file] });

export const QuizShare = ({ product }) => {
  const [busy, setBusy] = useState(false);
  const shareUrl = `${window.location.origin}/api/share/quiz/${product.id}`;
  const text = `Mijn shot is ${product.name.toUpperCase()} 🔥 Welke ben jij? Doe de smakenkiezer:`;

  const run = async (fn) => {
    setBusy(true);
    try {
      await fn();
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Delen lukte niet — probeer het opnieuw.");
    } finally {
      setBusy(false);
    }
  };

  const download = (file) => {
    const url = URL.createObjectURL(file);
    const a = document.createElement("a");
    a.href = url;
    a.download = file.name;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const shareNative = () =>
    run(async () => {
      const file = await getFile(product.id);
      if (canShareFile(file)) await navigator.share({ files: [file], text: `${text} ${shareUrl}` });
      else if (navigator.share) await navigator.share({ text, url: shareUrl });
      else {
        download(file);
        toast.success("Afbeelding opgeslagen — deel hem waar je wilt!");
      }
    });

  const shareInstagram = () =>
    run(async () => {
      const file = await getFile(product.id);
      if (canShareFile(file)) await navigator.share({ files: [file] });
      else {
        download(file);
        toast.success("Afbeelding opgeslagen — zet hem in je Instagram story!", { duration: 6000 });
      }
    });

  const copyLink = () =>
    run(async () => {
      await navigator.clipboard.writeText(`${text} ${shareUrl}`);
      toast.success("Link gekopieerd!");
    });

  const small = "h-10 border border-[var(--tha-border)] hover:border-[var(--tha-red)] transition-colors inline-flex items-center justify-center gap-1.5 text-[10px] font-mono-x tracking-widest";

  return (
    <div data-testid="flavour-quiz-share" className="mt-5 border-t border-[var(--tha-border)] pt-4">
      <button data-testid="flavour-quiz-share-native" onClick={shareNative} disabled={busy} className="w-full h-11 bg-white text-black font-display tracking-wider text-sm inline-flex items-center justify-center gap-2 transition-opacity hover:opacity-90 disabled:opacity-60">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Share2 size={14} />} DEEL JE SHOT
      </button>
      <div className="mt-2 grid grid-cols-3 gap-2">
        <a data-testid="flavour-quiz-share-whatsapp" href={`https://wa.me/?text=${encodeURIComponent(`${text} ${shareUrl}`)}`} target="_blank" rel="noreferrer" className={small}>
          <MessageCircle size={13} /> WHATSAPP
        </a>
        <button data-testid="flavour-quiz-share-instagram" onClick={shareInstagram} disabled={busy} className={small}>
          <Instagram size={13} /> INSTAGRAM
        </button>
        <button data-testid="flavour-quiz-share-copy" onClick={copyLink} disabled={busy} className={small}>
          <Link2 size={13} /> LINK
        </button>
      </div>
    </div>
  );
};
